import React from "react";
import Driver from "../components/driver/Driver";

const DriverPage = () => {
  return <Driver />;
};

export default DriverPage;
